<template>
  <Dialog
    v-model:visible="isVisible"
    :modal="true"
  >
    <template #header>
      <h3>{{ $t('lineidpage.dialog.delete.header') }}</h3>
    </template>


    <div class="confirmation-content">
      <span>{{ $t('lineidpage.dialog.delete.content') }}</span>
    </div>
    <template #footer>
      <Button
        :label="$t('lineidpage.dialog.abortButton')"
        icon="pi pi-times"
        class="p-button-rounded p-button-outlined"
        @click="close"
      />
      <Button
        :label="$t('lineidpage.dialog.confirmButton')"
        icon="pi pi-check"
        class="p-button-rounded p-button-outlined"
        @click="deleteLineId"
      />
    </template>
  </Dialog>
</template>

<script>
import Dialog from "primevue/dialog";
import Button from "primevue/button";

export default {
  name: 'LineIdDeleteDialog',
  components: {Dialog, Button},
  props: {
    lineId: {
      type: Object,
      default: null
    },
    visible: {
      type: Boolean,
      required: true
    }
  },
  emits: ['update:visible', 'delete'],
  computed: {
    isVisible: {
      get() {
        return this.visible
      },
      set(value) {
        this.$emit('update:visible', value)
      }
    }
  },
  methods: {
    close(){
      this.isVisible = false;
    },
    async deleteLineId() {
      try {
        const del = await this.$lineIdService.deleteLineId(this.lineId.id)
        if (del) {
          this.$emitter.emit('toast', { severity: 'success', message: 'lineidpage.toast.delete.success' })
          this.isVisible = false;
          this.$emit('delete', this.lineId);
        } else {
          this.$emitter.emit('toast', { severity: 'error', message: 'lineidpage.toast.delete.error' })
        }
      } catch (e) {
        const errors = e.response.data.map(error => this.$t(error)).join(', ')
        this.$emitter.emit('toast', { severity: 'error', message: errors })
      }
    },
  }
}
</script>
